import script from "./workload-view-performance-tasks.vue?vue&type=script&setup=true&lang=ts"
export * from "./workload-view-performance-tasks.vue?vue&type=script&setup=true&lang=ts"

import "./workload-view-performance-tasks.vue?vue&type=style&index=0&id=33cb4483&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33cb4483"]])

export default __exports__